<template>
  <nav class="navbar bg-dark  sticky-top">
    <div class="container">
      <a class="navbar-brand" href="#">

        <button class="navbar-toggler" type="button"
                data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

      </a>
      <div class="dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          Administrador
        </button>
        <ul class="dropdown-menu dropdown-menu-dark">
          <li><a @click="cerrarSesion" class="dropdown-item " href="#">Cerrar sesión</a></li>


        </ul>
      </div>
    </div>

  </nav>


  <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel"></h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">

      <div class="container">
        <div class="row">
          <div class="col">

            <div class="sidenav">
              <a id="categoria" class="link-sidenav" @click="cambioOption('categoria')">Categorias</a>
              <a id="contacto" class="link-sidenav" @click="cambioOption('contacto')">Contactos</a>
              <a id="noticia" class="link-sidenav" @click="cambioOption('noticia')">Noticias</a>
              <a id="producto" class="link-sidenav" @click="cambioOption('producto')">Productos</a>
              <!--          <a id="usuario" class="link-sidenav" @click="cambioOption('usuario')">Usuario</a>-->
            </div>

          </div>
        </div>

      </div>


    </div>
  </div>

</template>

<script>
import {useStore} from "vuex";

export default {
  name: "NavBar",
  setup(){

    const store = useStore();

    const cerrarSesion = () => {
      store.dispatch('userStore/cerrarSesion')
    }



    const cambioOption = (opcion) => {
      store.dispatch("cambiarOption", opcion)
    }







  return {
    cerrarSesion, cambioOption
  }

  }
}
</script>












<style scoped>
@font-face {
  font-family: Jose Thin;
  src: url('../assets/fonts/JosefinSans-Thin.ttf');
}

@font-face {
  font-family: Josefin Sans;
  src: url('../assets/fonts/JosefinSans-Regular.ttf');
}

.offcanvas {
  width: 18vw;
  background-color: #111;
}

.btn-close {
  background-color: #dd51a8;
}

.navbar-toggler {
  background-color: #dd51a8;
}


.link-sidenav {
  font-family: "Josefin Sans";
}


.sidenav {
  margin-top: 9vh;
  height: 100%;
  width: 160px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  padding-top: 20px;
}

.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #bebbbb;
  display: block;
}

.sidenav a:hover {
  cursor: pointer;
}

#categoria:hover {
  color: #37acff;
}


#contacto:hover {
  color: #37ffee;
}

#noticia:hover {
  color: #9e37ff;
}

#producto:hover {
  color: #ff7337;
}

#usuario:hover {
  color: #ffc037;
}


.main {
  margin-left: 160px; /* Same as the width of the sidenav */
  font-size: 28px; /* Increased text to enable scrolling */
  padding: 0px 10px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
</style>